module.exports = __webpack_public_path__ + "img/hippolyte-auguste-marinoni.1cf62c38.png";